const data = [
  {
    id: 1,
    name: 'David Akiba',
    image: require('../images/akiba.jpg'),
    url: 'http://davidakiba.weebly.com'
  },
  {
    id: 2,
    name: 'Allison Barnes',
    image: require('../images/barnes.jpg'),
    url: 'http://allisonbarnes.net/'
  },
  {
    id: 3,
    name: 'Ron Cowie',
    image: require('../images/cowie.jpg'),
    url: 'https://www.roncowiephoto.com/'
  },
  {
    id: 4,
    name: 'Barbara Diener',
    image: require('../images/diener.jpg'),
    url: 'http://www.barbaradienerphotography.com/'
  },
  {
    id: 5,
    name: 'Dab Farnum',
    image: require('../images/farnum.jpg'),
    url: 'http://danfarnum.com/'
  },
  {
    id: 6,
    name: 'David Gremp',
    image: require('../images/gremp.jpg'),
    url: 'http://davidgrempphotos.com'
  },
  {
    id: 7,
    name: 'Adam Holtzman',
    image: require('../images/holtzman.jpg'),
    url: 'http://adamholtzman.com/'
  },
  {
    id: 8,
    name: 'Rachel Hulin',
    image: require('../images/hulin.jpg'),
    url: 'http://www.rachelhulin.com/'
  },
  {
    id: 9,
    name: 'Rachel Jump',
    image: require('../images/jump.jpg'),
    url: 'http://www.racheljump.net/'
  },
  {
    id: 10,
    name: 'Asia Kepka',
    image: require('../images/kepka.jpg'),
    url: 'http://www.asiakepka.com/'
  },
  {
    id: 11,
    name: 'S. Gayle Stevens',
    image: require('../images/stevens.jpg'),
    url: 'http://www.sgaylestevens.com/'
  },
  {
    id: 12,
    name: 'Victor Yañez-Lazcano',
    image: require('../images/ya.jpg'),
    url: 'http://www.yanez-lazcano.com/'
  },
]

export default data



// WEBPACK FOOTER //
// ./src/images/data.js